import React from 'react';
import FooterMenu from 'src/dlc_components/footerMenu';
import LibSocials from 'src/uglib_components/libSocials';
import 'src/uglib_styles/footer.css'

function Footer() {

	let footer = <>
		<div id="footer-top">
			<div className="container">
				<footer>
					<div className="row align-items-center justify-content-between">	
						<FooterMenu />
					</div>
					<div className="row align-items-center justify-content-between">	
						<LibSocials />
					</div>
				</footer>
			</div>
		</div>
		<uofg-footer></uofg-footer>
	</>;

	return footer;

}

export default Footer
